/** Заголовок вида «nmID 123» из API — не показываем пользователю. */
export function isPlaceholderNmTitle(title) {
  if (title == null || typeof title !== "string") return true;
  return /^nmID\s*\d+$/i.test(title.trim());
}

/** Основная строка карточки: название товара или артикул вместо nmID. */
export function cardHeadingTitle(title, supplierArticle) {
  const art = (supplierArticle && String(supplierArticle).trim()) || "";
  const tt = (title && String(title).trim()) || "";
  if (isPlaceholderNmTitle(tt)) {
    return art || "Товар";
  }
  return tt || art || "Товар";
}

/** Вторая строка: артикул без подписи «Артикул»; null если уже показан в заголовке. */
export function cardArticleSubline(title, supplierArticle) {
  const art = (supplierArticle && String(supplierArticle).trim()) || "";
  if (!art) return null;
  const head = cardHeadingTitle(title, supplierArticle);
  if (head === art) return null;
  return art;
}
